export const CONSTANT_DATA = {
  cardbackcolor: "#347893",
};
export const BoxStyle = {
  border: "2px solid red",
  // padding: "20px",
  margin: "20px",
  //  width: '200px',
  // height: '200px',
};

export const FLOAT_REGEX = /^(?:\d*\.\d{0,2}|\d+|\s*)$/;
